import {handleResponseError} from './handleResponseError';

export const handleResponse = async <T>(response: Response): Promise<T> => {
    if (!response.ok) {
        await handleResponseError(response);
    }

    return response.json() as Promise<T>;
};
